/**
 * Every code the server's provider config field errors carry (field-error-codes.ts), kept
 * in step by hand: the copy check proves each one has a message.
 */
export const FIELD_ERROR_CODES = [
    'required',
    'httpsUrl',
    'urlCredentials',
    'host',
    'integer',
    'clarifyItemId',
    'sqlIdentifier',
    'sqlQualifiedName',
    'enum',
    'tooLong',
    'listItem',
    'tooMany',
    'duplicateExternalId',
    'clarifyPopulationSignal',
    'unknownField',
    'wrongScope',
    'advancedField',
    'alreadyEncrypted',
    'invalidJson',
    'invalidDate',
    'scadaItems',
    'invalidWindow',
    'windowTooLong',
    'blockedHost',
    'secretRequiredForNewDestination',
    'pathSegment',
    'nestedUnderValue',
    'unreadableStored',
] as const;

export type FieldErrorCode = (typeof FIELD_ERROR_CODES)[number];

/**
 * Codes only the client reports. The server answers `required` for a new pen's missing
 * secret; the form says why it cannot reuse the site's credential instead.
 */
export const CLIENT_ERROR_CODES = ['newPenSecretRequired'] as const;

export type ClientErrorCode = (typeof CLIENT_ERROR_CODES)[number];

export function isFieldErrorCode(code: string): code is FieldErrorCode | ClientErrorCode {
    return (
        FIELD_ERROR_CODES.some((known) => known === code) ||
        CLIENT_ERROR_CODES.some((known) => known === code)
    );
}

/**
 * Clarify item ids are XIDs: 12 bytes in lowercase base32hex, so the last character only
 * carries 0 or g (R28). Clarify fails a whole call on one malformed id.
 */
export const CLARIFY_ITEM_ID_PATTERN = /^[0-9a-v]{19}[0g]$/;

/** Mercatus and Arnalax unit ids: a plain integer that fits a signed 64-bit key. */
export const INTEGER_ITEM_PATTERN = /^\d{1,18}$/;
